/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResearchBarRouteImport } from './routes/research-bar'
import { Route as BookingRouteImport } from './routes/_booking'
import { Route as Blue_headerRouteImport } from './routes/_blue_header'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as ResearchBarEmbedRouteImport } from './routes/research-bar.embed'
import { Route as PaymentConfirmationStatusRouteImport } from './routes/payment-confirmation.$status'
import { Route as BookingInformationsRouteImport } from './routes/_booking/informations'
import { Route as BookingCheckoutRouteImport } from './routes/_booking/checkout'
import { Route as BookingAssurancesRouteImport } from './routes/_booking/assurances'
import { Route as Blue_headerEstimateSentRouteImport } from './routes/_blue_header/estimate-sent'
import { Route as Blue_headerEstimateRouteImport } from './routes/_blue_header/estimate'
import { Route as AuthenticatedLayoutRouteImport } from './routes/_authenticated/_layout'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgottenPasswordRouteImport } from './routes/_auth/forgotten-password'
import { Route as Blue_headerPayerAcompteIndexRouteImport } from './routes/_blue_header/payer-acompte/index'
import { Route as AuthenticatedLayoutIndexRouteImport } from './routes/_authenticated/_layout/index'
import { Route as BookingFlightsResultsRouteImport } from './routes/_booking/flights.results'
import { Route as Blue_headerReservationEstimateResponseIdRouteImport } from './routes/_blue_header/reservation.$estimateResponseId'
import { Route as Blue_headerReservationConfirmationReservationIdRouteImport } from './routes/_blue_header/reservation-confirmation.$reservationId'
import { Route as AuthenticatedLayoutPersonalInformationsRouteImport } from './routes/_authenticated/_layout/personal-informations'
import { Route as AuthenticatedLayoutBookingBookingRefRouteImport } from './routes/_authenticated/_layout/booking.$bookingRef'

const ResearchBarRoute = ResearchBarRouteImport.update({
  id: '/research-bar',
  path: '/research-bar',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingRoute = BookingRouteImport.update({
  id: '/_booking',
  getParentRoute: () => rootRouteImport,
} as any)
const Blue_headerRoute = Blue_headerRouteImport.update({
  id: '/_blue_header',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ResearchBarEmbedRoute = ResearchBarEmbedRouteImport.update({
  id: '/embed',
  path: '/embed',
  getParentRoute: () => ResearchBarRoute,
} as any)
const PaymentConfirmationStatusRoute =
  PaymentConfirmationStatusRouteImport.update({
    id: '/payment-confirmation/$status',
    path: '/payment-confirmation/$status',
    getParentRoute: () => rootRouteImport,
  } as any)
const BookingInformationsRoute = BookingInformationsRouteImport.update({
  id: '/informations',
  path: '/informations',
  getParentRoute: () => BookingRoute,
} as any)
const BookingCheckoutRoute = BookingCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => BookingRoute,
} as any)
const BookingAssurancesRoute = BookingAssurancesRouteImport.update({
  id: '/assurances',
  path: '/assurances',
  getParentRoute: () => BookingRoute,
} as any)
const Blue_headerEstimateSentRoute = Blue_headerEstimateSentRouteImport.update({
  id: '/estimate-sent',
  path: '/estimate-sent',
  getParentRoute: () => Blue_headerRoute,
} as any)
const Blue_headerEstimateRoute = Blue_headerEstimateRouteImport.update({
  id: '/estimate',
  path: '/estimate',
  getParentRoute: () => Blue_headerRoute,
} as any)
const AuthenticatedLayoutRoute = AuthenticatedLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgottenPasswordRoute = AuthForgottenPasswordRouteImport.update({
  id: '/forgotten-password',
  path: '/forgotten-password',
  getParentRoute: () => AuthRoute,
} as any)
const Blue_headerPayerAcompteIndexRoute =
  Blue_headerPayerAcompteIndexRouteImport.update({
    id: '/payer-acompte/',
    path: '/payer-acompte/',
    getParentRoute: () => Blue_headerRoute,
  } as any)
const AuthenticatedLayoutIndexRoute =
  AuthenticatedLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const BookingFlightsResultsRoute = BookingFlightsResultsRouteImport.update({
  id: '/flights/results',
  path: '/flights/results',
  getParentRoute: () => BookingRoute,
} as any)
const Blue_headerReservationEstimateResponseIdRoute =
  Blue_headerReservationEstimateResponseIdRouteImport.update({
    id: '/reservation/$estimateResponseId',
    path: '/reservation/$estimateResponseId',
    getParentRoute: () => Blue_headerRoute,
  } as any)
const Blue_headerReservationConfirmationReservationIdRoute =
  Blue_headerReservationConfirmationReservationIdRouteImport.update({
    id: '/reservation-confirmation/$reservationId',
    path: '/reservation-confirmation/$reservationId',
    getParentRoute: () => Blue_headerRoute,
  } as any)
const AuthenticatedLayoutPersonalInformationsRoute =
  AuthenticatedLayoutPersonalInformationsRouteImport.update({
    id: '/personal-informations',
    path: '/personal-informations',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutBookingBookingRefRoute =
  AuthenticatedLayoutBookingBookingRefRouteImport.update({
    id: '/booking/$bookingRef',
    path: '/booking/$bookingRef',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/research-bar': typeof ResearchBarRouteWithChildren
  '/forgotten-password': typeof AuthForgottenPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/estimate': typeof Blue_headerEstimateRoute
  '/estimate-sent': typeof Blue_headerEstimateSentRoute
  '/assurances': typeof BookingAssurancesRoute
  '/checkout': typeof BookingCheckoutRoute
  '/informations': typeof BookingInformationsRoute
  '/payment-confirmation/$status': typeof PaymentConfirmationStatusRoute
  '/research-bar/embed': typeof ResearchBarEmbedRoute
  '/personal-informations': typeof AuthenticatedLayoutPersonalInformationsRoute
  '/reservation-confirmation/$reservationId': typeof Blue_headerReservationConfirmationReservationIdRoute
  '/reservation/$estimateResponseId': typeof Blue_headerReservationEstimateResponseIdRoute
  '/flights/results': typeof BookingFlightsResultsRoute
  '/': typeof AuthenticatedLayoutIndexRoute
  '/payer-acompte': typeof Blue_headerPayerAcompteIndexRoute
  '/booking/$bookingRef': typeof AuthenticatedLayoutBookingBookingRefRoute
}
export interface FileRoutesByTo {
  '/research-bar': typeof ResearchBarRouteWithChildren
  '/forgotten-password': typeof AuthForgottenPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/estimate': typeof Blue_headerEstimateRoute
  '/estimate-sent': typeof Blue_headerEstimateSentRoute
  '/assurances': typeof BookingAssurancesRoute
  '/checkout': typeof BookingCheckoutRoute
  '/informations': typeof BookingInformationsRoute
  '/payment-confirmation/$status': typeof PaymentConfirmationStatusRoute
  '/research-bar/embed': typeof ResearchBarEmbedRoute
  '/personal-informations': typeof AuthenticatedLayoutPersonalInformationsRoute
  '/reservation-confirmation/$reservationId': typeof Blue_headerReservationConfirmationReservationIdRoute
  '/reservation/$estimateResponseId': typeof Blue_headerReservationEstimateResponseIdRoute
  '/flights/results': typeof BookingFlightsResultsRoute
  '/': typeof AuthenticatedLayoutIndexRoute
  '/payer-acompte': typeof Blue_headerPayerAcompteIndexRoute
  '/booking/$bookingRef': typeof AuthenticatedLayoutBookingBookingRefRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_blue_header': typeof Blue_headerRouteWithChildren
  '/_booking': typeof BookingRouteWithChildren
  '/research-bar': typeof ResearchBarRouteWithChildren
  '/_auth/forgotten-password': typeof AuthForgottenPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_authenticated/_layout': typeof AuthenticatedLayoutRouteWithChildren
  '/_blue_header/estimate': typeof Blue_headerEstimateRoute
  '/_blue_header/estimate-sent': typeof Blue_headerEstimateSentRoute
  '/_booking/assurances': typeof BookingAssurancesRoute
  '/_booking/checkout': typeof BookingCheckoutRoute
  '/_booking/informations': typeof BookingInformationsRoute
  '/payment-confirmation/$status': typeof PaymentConfirmationStatusRoute
  '/research-bar/embed': typeof ResearchBarEmbedRoute
  '/_authenticated/_layout/personal-informations': typeof AuthenticatedLayoutPersonalInformationsRoute
  '/_blue_header/reservation-confirmation/$reservationId': typeof Blue_headerReservationConfirmationReservationIdRoute
  '/_blue_header/reservation/$estimateResponseId': typeof Blue_headerReservationEstimateResponseIdRoute
  '/_booking/flights/results': typeof BookingFlightsResultsRoute
  '/_authenticated/_layout/': typeof AuthenticatedLayoutIndexRoute
  '/_blue_header/payer-acompte/': typeof Blue_headerPayerAcompteIndexRoute
  '/_authenticated/_layout/booking/$bookingRef': typeof AuthenticatedLayoutBookingBookingRefRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/research-bar'
    | '/forgotten-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/estimate'
    | '/estimate-sent'
    | '/assurances'
    | '/checkout'
    | '/informations'
    | '/payment-confirmation/$status'
    | '/research-bar/embed'
    | '/personal-informations'
    | '/reservation-confirmation/$reservationId'
    | '/reservation/$estimateResponseId'
    | '/flights/results'
    | '/'
    | '/payer-acompte'
    | '/booking/$bookingRef'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/research-bar'
    | '/forgotten-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/estimate'
    | '/estimate-sent'
    | '/assurances'
    | '/checkout'
    | '/informations'
    | '/payment-confirmation/$status'
    | '/research-bar/embed'
    | '/personal-informations'
    | '/reservation-confirmation/$reservationId'
    | '/reservation/$estimateResponseId'
    | '/flights/results'
    | '/'
    | '/payer-acompte'
    | '/booking/$bookingRef'
  id:
    | '__root__'
    | '/_auth'
    | '/_authenticated'
    | '/_blue_header'
    | '/_booking'
    | '/research-bar'
    | '/_auth/forgotten-password'
    | '/_auth/login'
    | '/_auth/register'
    | '/_auth/reset-password'
    | '/_authenticated/_layout'
    | '/_blue_header/estimate'
    | '/_blue_header/estimate-sent'
    | '/_booking/assurances'
    | '/_booking/checkout'
    | '/_booking/informations'
    | '/payment-confirmation/$status'
    | '/research-bar/embed'
    | '/_authenticated/_layout/personal-informations'
    | '/_blue_header/reservation-confirmation/$reservationId'
    | '/_blue_header/reservation/$estimateResponseId'
    | '/_booking/flights/results'
    | '/_authenticated/_layout/'
    | '/_blue_header/payer-acompte/'
    | '/_authenticated/_layout/booking/$bookingRef'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  Blue_headerRoute: typeof Blue_headerRouteWithChildren
  BookingRoute: typeof BookingRouteWithChildren
  ResearchBarRoute: typeof ResearchBarRouteWithChildren
  PaymentConfirmationStatusRoute: typeof PaymentConfirmationStatusRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/research-bar': {
      id: '/research-bar'
      path: '/research-bar'
      fullPath: '/research-bar'
      preLoaderRoute: typeof ResearchBarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_booking': {
      id: '/_booking'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof BookingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_blue_header': {
      id: '/_blue_header'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof Blue_headerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/research-bar/embed': {
      id: '/research-bar/embed'
      path: '/embed'
      fullPath: '/research-bar/embed'
      preLoaderRoute: typeof ResearchBarEmbedRouteImport
      parentRoute: typeof ResearchBarRoute
    }
    '/payment-confirmation/$status': {
      id: '/payment-confirmation/$status'
      path: '/payment-confirmation/$status'
      fullPath: '/payment-confirmation/$status'
      preLoaderRoute: typeof PaymentConfirmationStatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_booking/informations': {
      id: '/_booking/informations'
      path: '/informations'
      fullPath: '/informations'
      preLoaderRoute: typeof BookingInformationsRouteImport
      parentRoute: typeof BookingRoute
    }
    '/_booking/checkout': {
      id: '/_booking/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof BookingCheckoutRouteImport
      parentRoute: typeof BookingRoute
    }
    '/_booking/assurances': {
      id: '/_booking/assurances'
      path: '/assurances'
      fullPath: '/assurances'
      preLoaderRoute: typeof BookingAssurancesRouteImport
      parentRoute: typeof BookingRoute
    }
    '/_blue_header/estimate-sent': {
      id: '/_blue_header/estimate-sent'
      path: '/estimate-sent'
      fullPath: '/estimate-sent'
      preLoaderRoute: typeof Blue_headerEstimateSentRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_blue_header/estimate': {
      id: '/_blue_header/estimate'
      path: '/estimate'
      fullPath: '/estimate'
      preLoaderRoute: typeof Blue_headerEstimateRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_authenticated/_layout': {
      id: '/_authenticated/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgotten-password': {
      id: '/_auth/forgotten-password'
      path: '/forgotten-password'
      fullPath: '/forgotten-password'
      preLoaderRoute: typeof AuthForgottenPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_blue_header/payer-acompte/': {
      id: '/_blue_header/payer-acompte/'
      path: '/payer-acompte'
      fullPath: '/payer-acompte'
      preLoaderRoute: typeof Blue_headerPayerAcompteIndexRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_authenticated/_layout/': {
      id: '/_authenticated/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_booking/flights/results': {
      id: '/_booking/flights/results'
      path: '/flights/results'
      fullPath: '/flights/results'
      preLoaderRoute: typeof BookingFlightsResultsRouteImport
      parentRoute: typeof BookingRoute
    }
    '/_blue_header/reservation/$estimateResponseId': {
      id: '/_blue_header/reservation/$estimateResponseId'
      path: '/reservation/$estimateResponseId'
      fullPath: '/reservation/$estimateResponseId'
      preLoaderRoute: typeof Blue_headerReservationEstimateResponseIdRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_blue_header/reservation-confirmation/$reservationId': {
      id: '/_blue_header/reservation-confirmation/$reservationId'
      path: '/reservation-confirmation/$reservationId'
      fullPath: '/reservation-confirmation/$reservationId'
      preLoaderRoute: typeof Blue_headerReservationConfirmationReservationIdRouteImport
      parentRoute: typeof Blue_headerRoute
    }
    '/_authenticated/_layout/personal-informations': {
      id: '/_authenticated/_layout/personal-informations'
      path: '/personal-informations'
      fullPath: '/personal-informations'
      preLoaderRoute: typeof AuthenticatedLayoutPersonalInformationsRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/booking/$bookingRef': {
      id: '/_authenticated/_layout/booking/$bookingRef'
      path: '/booking/$bookingRef'
      fullPath: '/booking/$bookingRef'
      preLoaderRoute: typeof AuthenticatedLayoutBookingBookingRefRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
  }
}

interface AuthRouteChildren {
  AuthForgottenPasswordRoute: typeof AuthForgottenPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgottenPasswordRoute: AuthForgottenPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedLayoutRouteChildren {
  AuthenticatedLayoutPersonalInformationsRoute: typeof AuthenticatedLayoutPersonalInformationsRoute
  AuthenticatedLayoutIndexRoute: typeof AuthenticatedLayoutIndexRoute
  AuthenticatedLayoutBookingBookingRefRoute: typeof AuthenticatedLayoutBookingBookingRefRoute
}

const AuthenticatedLayoutRouteChildren: AuthenticatedLayoutRouteChildren = {
  AuthenticatedLayoutPersonalInformationsRoute:
    AuthenticatedLayoutPersonalInformationsRoute,
  AuthenticatedLayoutIndexRoute: AuthenticatedLayoutIndexRoute,
  AuthenticatedLayoutBookingBookingRefRoute:
    AuthenticatedLayoutBookingBookingRefRoute,
}

const AuthenticatedLayoutRouteWithChildren =
  AuthenticatedLayoutRoute._addFileChildren(AuthenticatedLayoutRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedLayoutRoute: typeof AuthenticatedLayoutRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedLayoutRoute: AuthenticatedLayoutRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface Blue_headerRouteChildren {
  Blue_headerEstimateRoute: typeof Blue_headerEstimateRoute
  Blue_headerEstimateSentRoute: typeof Blue_headerEstimateSentRoute
  Blue_headerReservationConfirmationReservationIdRoute: typeof Blue_headerReservationConfirmationReservationIdRoute
  Blue_headerReservationEstimateResponseIdRoute: typeof Blue_headerReservationEstimateResponseIdRoute
  Blue_headerPayerAcompteIndexRoute: typeof Blue_headerPayerAcompteIndexRoute
}

const Blue_headerRouteChildren: Blue_headerRouteChildren = {
  Blue_headerEstimateRoute: Blue_headerEstimateRoute,
  Blue_headerEstimateSentRoute: Blue_headerEstimateSentRoute,
  Blue_headerReservationConfirmationReservationIdRoute:
    Blue_headerReservationConfirmationReservationIdRoute,
  Blue_headerReservationEstimateResponseIdRoute:
    Blue_headerReservationEstimateResponseIdRoute,
  Blue_headerPayerAcompteIndexRoute: Blue_headerPayerAcompteIndexRoute,
}

const Blue_headerRouteWithChildren = Blue_headerRoute._addFileChildren(
  Blue_headerRouteChildren,
)

interface BookingRouteChildren {
  BookingAssurancesRoute: typeof BookingAssurancesRoute
  BookingCheckoutRoute: typeof BookingCheckoutRoute
  BookingInformationsRoute: typeof BookingInformationsRoute
  BookingFlightsResultsRoute: typeof BookingFlightsResultsRoute
}

const BookingRouteChildren: BookingRouteChildren = {
  BookingAssurancesRoute: BookingAssurancesRoute,
  BookingCheckoutRoute: BookingCheckoutRoute,
  BookingInformationsRoute: BookingInformationsRoute,
  BookingFlightsResultsRoute: BookingFlightsResultsRoute,
}

const BookingRouteWithChildren =
  BookingRoute._addFileChildren(BookingRouteChildren)

interface ResearchBarRouteChildren {
  ResearchBarEmbedRoute: typeof ResearchBarEmbedRoute
}

const ResearchBarRouteChildren: ResearchBarRouteChildren = {
  ResearchBarEmbedRoute: ResearchBarEmbedRoute,
}

const ResearchBarRouteWithChildren = ResearchBarRoute._addFileChildren(
  ResearchBarRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  Blue_headerRoute: Blue_headerRouteWithChildren,
  BookingRoute: BookingRouteWithChildren,
  ResearchBarRoute: ResearchBarRouteWithChildren,
  PaymentConfirmationStatusRoute: PaymentConfirmationStatusRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
